<template>
    <div class="row">
        <div class="col">
            <label for="country">{{'Country' | trans}}</label>
            <select @change="getAgencyPhones" v-model="country" name="country" id="country" class="form-control">
	            <option value="">-- {{'Country' | trans}} --</option>
	            <option v-for="(c, index) in countries" :value="c.C_Country_ID">{{c.Name}}</option>
            </select>
            <div v-if="loadingAgencyPhones" class="d-flex align-items-center justify-content-center mt-4 mb-4">
                <pulse-loader :loading="loadingAgencyPhones" :color="color" :size="size"></pulse-loader>
            </div>
            <div v-show="agencyPhones.length">
                <br>
                <h3>{{'Phones' | trans}}:</h3>
                <table class="table">
                    <tr>
                        <th>{{'Name' | trans}}</th>
                        <th>{{'Phone' | trans}}</th>
                    </tr>
                    <tr v-for="(item, index) in agencyPhones">
                        <td>{{item.name}}</td>
                        <td>{{item.phone}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
	import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    export default {
	    components: {
		    'PulseLoader': PulseLoader,
	    },
        props: ['countries', 'user'],
        data() {
            return {
                country: '',
                agencyPhones: [],
                loadingAgencyPhones: false,
	            color: '#210069',
	            size: '15px'
            }
        },
        mounted() {
            this.$nextTick(() => this.getAgencyPhones());
            if(this.user) {
	            country = this.user.C_Country_ID;
            }
        },
        methods: {
            async getAgencyPhones() {
                this.loadingAgencyPhones = true;
                this.agencyPhones = [];
                let result = await axios.get(`/countries/${this.country}/agencyPhones`)
                    .finally(() => this.loadingAgencyPhones = false);
                this.agencyPhones = result.data;
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/contacts.vue